import { render, staticRenderFns } from "./NotePreview.vue?vue&type=template&id=177cbf17&scoped=true&"
import script from "./NotePreview.vue?vue&type=script&lang=js&"
export * from "./NotePreview.vue?vue&type=script&lang=js&"
import style0 from "./NotePreview.vue?vue&type=style&index=0&id=177cbf17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177cbf17",
  null
  
)

export default component.exports